import React from 'react';
import classNames from 'classnames';
import InfoIcon from '@atlaskit/icon/glyph/info';
import Tooltip from '@atlaskit/tooltip';
import './sortable-table-head.scss';

interface SortableProps {
  isAscSorted: boolean | undefined;
  handleSorting: () => void;
  columnName: string;
  className?: string;
  tooltipText?: string;
  /* In some cases eg. Last updated column in Quotes table, the sort icon should be reversed because instead of
  showing the exact date, we show the duration from now. Passing shouldReverseSortIcon as true handles the case. */
  shouldReverseSortIcon?: boolean;
}
const SortableTableHead = ({
  isAscSorted,
  handleSorting,
  columnName,
  className,
  tooltipText,
  shouldReverseSortIcon,
}: SortableProps) => {
  // Note: Do not highlight the asc and desc icons when the isAscSorted is undefined
  let sortedClass;
  const ascendingSortClass = 'sort-icon-asc';
  const descendingSortClass = 'sort-icon-desc';

  if (typeof isAscSorted !== 'undefined') {
    if (isAscSorted) {
      sortedClass = shouldReverseSortIcon ? descendingSortClass : ascendingSortClass;
    } else {
      sortedClass = shouldReverseSortIcon ? ascendingSortClass : descendingSortClass;
    }
  } else {
    sortedClass = 'no-sorting';
  }

  const testId = 'sortable-' + columnName.split(' ').join('-').toLowerCase();

  return (
    <th onClick={handleSorting} className={classNames('sortable', className)} data-testId={testId}>
      {tooltipText && (
        <Tooltip content={tooltipText} tag="span" testId="sortable-table-head-tooltip">
          <InfoIcon label="Info" size="small" testId="sortable-table-head-info-icon" />{' '}
        </Tooltip>
      )}
      <span>{columnName}</span>
      <span>
        <span className={'sort-icon ' + sortedClass} data-testId={sortedClass} />
      </span>
    </th>
  );
};

export default SortableTableHead;
